// extracted by mini-css-extract-plugin
export default {"categoryBox":"Category_categoryBox__fvn-d","coverImage":"Category_coverImage__STLK8","title":"Category_title__FIt3O"};